type SortableHeaderProps<T> = {
  label: string;
  sortKey: keyof T;
  sortData: (key: keyof T) => void;
  getSortIndicator: (key: keyof T) => string;
  isAction?: boolean;
};

function SortableHeader<T>({ 
  label, 
  sortKey, 
  sortData, 
  getSortIndicator,
  isAction = false 
}: SortableHeaderProps<T>) {
  return (
    <>
      <th 
        onClick={!isAction ? () => sortData(sortKey) : undefined} 
        className={`table-header ${!isAction ? 'sortable-header' : 'action-header'}`}
        data-active={!isAction && !!getSortIndicator(sortKey)}
      >
        <div className="header-content">
          <span className="label">{label}</span>
          {!isAction && <span className="sort-indicator">{getSortIndicator(sortKey)}</span>}
        </div>
      </th>

      <style>
        {`
          .table-header {
            background-color: #f8f9fa;
            position: relative;
            text-align: center;
            transition: all 0.2s ease;
            padding: 0 !important;
            color: #11181F;
            font-weight: 500;
          }

          .sortable-header {
            cursor: pointer;
            user-select: none;
          }

          .action-header {
            cursor: default;
          }

          .sortable-header:hover {
            background-color: #e9ecef;
          }

          .header-content {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 12px 8px;
            height: 100%;
          }

          .sort-indicator {
            display: inline-block;
            width: 12px;
            color: #6c757d;
            font-weight: bold;
          }

          .sortable-header:hover .sort-indicator {
            color: #495057;
          }

          .sortable-header:active {
            background-color: #dee2e6;
          }

          .sortable-header::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: #0d6efd;
            transform: scaleX(0);
            transition: transform 0.2s ease;
          }

          .sortable-header:hover::after {
            transform: scaleX(1);
          }

          .sortable-header[data-active='true'] {
            background-color: #e9ecef;
          }

          .label {
            display: inline-block;
            text-align: center;
          }
        `}
      </style>
    </>
  );
}

export default SortableHeader;